import { render, staticRenderFns } from "./AIAHeader.vue?vue&type=template&id=77aa464c&"
import script from "./AIAHeader.vue?vue&type=script&lang=js&"
export * from "./AIAHeader.vue?vue&type=script&lang=js&"
import style0 from "./AIAHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports